import React from 'react';
import './ChecklistModal.css';

function ChecklistModal({ testList, selectedTests, onCheckboxChange, onSave, onClose }) {
  return (
    <div className="checklist-modal-background">
      <div className="checklist-modal-content">
        <div className="checklist-modal-header">
          추천 검사
        </div>
        <div className="checklist-modal-body">
          {testList.map((test) => (
            <div key={test.id} className="checklist-modal-item">
              {/* <input
                type="checkbox"
                id={`test-${test.id}`}
                className="checklist-modal-checkbox"
                checked={selectedTests.includes(test.id)}
                onChange={() => onCheckboxChange(test.id)}
              /> */}
              <label htmlFor={`test-${test.id}`} className="checklist-modal-label">{test.testName}</label>
            </div>
          ))}
        </div>
        <div className="checklist-modal-actions">
          {/* <button onClick={onSave} className="checklist-modal-save-btn" disabled={selectedTests.length === 0}>저장</button> */}
          <button onClick={onClose} className="checklist-modal-close-btn">닫기</button>
        </div>
      </div>
    </div>
  );
}

export default ChecklistModal;
